<template>
    <el-form label-position="left" label-width="110px">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
       <el-form-item label="To">
                <fg-input type="text" name="email" v-model="message.email" disabled></fg-input>
            </el-form-item>
        <el-form-item label="Delivery Type">
                 <fg-input type="text"  name="deliveryType" v-model="deliveryType" disabled> </fg-input> 
            </el-form-item>
             <el-form-item label="Subject">
                 <fg-input type="text"   name="subject" v-model="message.subject" disabled> </fg-input> 
            </el-form-item>  
            <el-form-item label="Message">
                 <TextEditor ref="textEditor" v-model="message.body" />
            </el-form-item>      
             <el-form-item>
                <el-button type="primary"  @click="saveAndSendDocument(message.subject,message.body)">Send</el-button>
            </el-form-item>                              
     </el-form>
</template>
<script>
import resourcesServices from "src/services/Resources/resourcesServices.js"
import TextEditor from "@/components/UIComponents/TextEditor.vue"
import Loading from "vue-loading-overlay";
export default {
  components:{
    Loading,
    TextEditor
  },
  props:{
docId:{
  type:String,
  default:""
},
  },
    data(){
        return{
           deliveryType:'System Inbox + Brief Message',
           message:[],
           documentId:'',
          currentUser:this.$store.getters["currentUser/getCurrentUsersLogin"],
          isLoading:false,
        }
    },
    watch:{
   async  docId(id){
     this.$refs.textEditor.clearContent(); 
       await this.getDocumentMsgTemplate(id);
       this.documentId=this.docId
     }
    },
    methods:{
       async getDocumentMsgTemplate(id){
         this.isLoading=true;
          var pinnedUser=this.$store.getters["pinnedUser/getPinnedUsersLogin"];
            var msg= await resourcesServices.GetAssignDocumentMsgTemplate(pinnedUser,id);
            if(msg.result)
            {
             this.message=msg.result;
             this.$refs.textEditor.append(this.message.body);
             this.isLoading=false;
              
            }
        },
      async  saveAndSendDocument(subject,body){
       this.isLoading=true;
      var  AssignDocument={
          login:this.$store.getters["pinnedUser/getPinnedUsersLogin"],
          documentId:this.documentId,
          currentUser:this.currentUser,
          subject:subject,
          messageBody:body,
          practiceCode:this.$store.getters["currentUser/getCurrentUsersPractice" ]
        }
          var status=await resourcesServices.saveAndSendDocumentSummary(AssignDocument)
          if(status.result)
          {
            this.isLoading=false;
             this.$notify({
              title: 'Document Assigned!',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'success',
              timeout: 500,
              showClose: false
          });
          this.$refs.textEditor.clearContent(); 
           this.$emit('close-modal')
          }
          else{
            this.isLoading=false;
             this.$notify({
              title: 'Something went wrong!',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'error',
              timeout: 500,
              showClose: false
          });
          this.$refs.textEditor.clearContent(); 
           this.$emit('close-modal')
          }
        }
    },
   async created(){
     this.documentId=this.docId
   await this.getDocumentMsgTemplate(this.documentId)
    }

}
</script>
